import React from 'react';

const StarbeatNoticeEN = () => {
  return (
    <>
      <ul className='starbeat-notice-desc-group'>
        <li className='starbeat-notice-desc-list'>
          <p className='starbeat-notice-desc-title'>Notice of using Star Beats</p>
          <ul className='starbeat-notice-desc-depth2-group'>
            <li className='starbeat-notice-desc-depth2-list'>
              - Purchased Beats can be used to buy Mubeat Live products, fund ads on the Mubeat app, and participate in
              the Star Beat playground.
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - Purchased Beats can be used on both the website and the AOS app, as well as the iOS app.
            </li>
            <li className='starbeat-notice-desc-depth2-list'>- Expiration date: 5 years from the obtained date.</li>
          </ul>
        </li>
        <li className='starbeat-notice-desc-list'>
          <p className='starbeat-notice-desc-title'>Purchase Precautions</p>
          <ul className='starbeat-notice-desc-depth2-group'>
            <li className='starbeat-notice-desc-depth2-list'>- VAT is included in the Star Beat price.</li>
            <li className='starbeat-notice-desc-depth2-list'>
              - When purchasing Star Beats, taxes are applied separately, determined by the country of residence.
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - If a minor has conducted a transaction without the consent of a legal representative, either the minor
              or the legal representative may cancel the purchase. However, if the minor has misrepresented themselves
              as an adult or the legal representative, the transaction cannot be canceled.
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - If you repeatedly request to cancel or refund a transaction for the same reasons, or if you continue to
              cancel or refund the transaction for unjustified reasons, you may face restrictions in using our services.
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - Refund is only allowed within 7 days (subscription withdrawal period) of Star Beat purchases.
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - Refund requests for purchased Star Beats are only allowed within 7 days from the date of purchase if
              they have not been used.
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - You can request a refund through the Mubeat App &gt; Settings &gt; Send feedback, or send an email
              directly at support@mubeat.tv to request a refund. Please use the format below when requesting a refund.
              <br />
              &lt;Email Format&gt;
              <br />
              Subject: [Refund Request for Star Beat - WEB Purchase]
              <br />
              Body:
              <ul className='starbeat-notice-desc-depth3-group'>
                <li className='starbeat-notice-desc-depth3-list'>
                  1) The Mubeat email account used for Star Beat purchase
                </li>
                <li className='starbeat-notice-desc-depth3-list'>
                  2) Login Method (You can check through My Page&gt; Logged in acount)
                </li>
                <li className='starbeat-notice-desc-depth3-list'>
                  3) The name of the Star Beat product purchased, product price
                </li>
                <li className='starbeat-notice-desc-depth3-list'>4) Date of purchase</li>
                <li className='starbeat-notice-desc-depth3-list'>5) Reason of refund</li>
              </ul>
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - Please note that a full refund may take some time to be processed. Refunds are not available in any of
              the cases listed below.
              <ul className='starbeat-notice-desc-depth3-group'>
                <li className='starbeat-notice-desc-depth3-list'>
                  &#9312; Any payment that was processed without charge, whether through an event, coupon, or reward
                </li>
                <li className='starbeat-notice-desc-depth3-list'>&#9313; If there is a history of usage</li>
                <li className='starbeat-notice-desc-depth3-list'>
                  &#9314; When the refund period has passed, based on each payment method
                </li>
                <li className='starbeat-notice-desc-depth3-list'>&#9315; When the purchase was made negligently</li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </>
  );
};

export default StarbeatNoticeEN;
